module.exports = __webpack_public_path__ + "6f3e245c297212fbf42af856367ac653.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-global-search/sp-global-search.html
// module id = 1005
// module chunks = 0